import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker as AirbnbDateRangePicker } from 'react-dates';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';


import './date-range-picker.css';

moment.updateLocale('de', {
  invalidDate: 'Kein Datum',
});
const styles = {
  infoBox: {
    marginLeft: '22px',
    marginBottom: '0px',
    display: 'block',
  },
};

class DateRangePicker extends Component {
  constructor(props) {
    super(props);

    const { startDate, endDate } = props;

    this.state = {
      focusedInput: null,
      startHours: startDate.hours(),
      startMinutes: startDate.minutes(),
      endHours: endDate.hours(),
      endMinutes: endDate.minutes(),
    };
  }

  setStartTime = (startDate) => {
    if (!startDate || !startDate.isValid()) {
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    const dateString = startDate._i;

    // if the date was written use hour and minute from the input string
    if (!Number.isInteger(dateString) && dateString) {
      const pos = dateString.search(' ');
      const hours = dateString.slice(pos + 1, pos + 3);
      const minutes = dateString.slice(pos + 4, pos + 6);
      startDate.hours(hours);
      startDate.minutes(minutes);
      this.setState({ startHours: hours, startMinutes: minutes });
    // if the date was picked, use the last written hour and minute as the picker sets it to 12:00 otherwise
    } else {
      const { startDate: startDateProp } = this.props;

      startDate.hours(startDateProp.hours());
      startDate.minutes(startDateProp.minutes());
    }
  }

  setEndTime = (endDate) => {
    if (!endDate || !endDate.isValid()) {
      return;
    }
    // eslint-disable-next-line no-underscore-dangle
    const dateString = endDate._i;
    if (!Number.isInteger(dateString) && dateString) {
      const pos = dateString.search(' ');
      const hours = dateString.slice(pos + 1, pos + 3);
      const minutes = dateString.slice(pos + 4, pos + 6);
      endDate.hours(hours);
      endDate.minutes(minutes);
      this.setState({ endHours: hours, endMinutes: minutes });
    } else {
      const { endDate: endDateProp } = this.props;

      endDate.hours(endDateProp.hours());
      endDate.minutes(endDateProp.minutes());
    }
  }


  handleDatesChanged = (event) => {
    const { onDatesChanged } = this.props;

    this.setStartTime(event.startDate);
    this.setEndTime(event.endDate);

    if (!event.endDate || !event.endDate.isValid()) {
      return;
    }

    if (!event.startDate || !event.startDate.isValid()) {
      return;
    }

    onDatesChanged({ startDate: event.startDate?.unix(), endDate: event.endDate?.unix() });
  }

  handleFocusChange = (fi) => {
    this.setState({ focusedInput: fi });
  }

  render() {
    const {
      startDate, endDate, disabled, title, useDesktopLayout, supressPortal,
    } = this.props;
    const { focusedInput } = this.state;

    const usePortal = !supressPortal && !useDesktopLayout;

    return (
      <AirbnbDateRangePicker
        appendToBody
        startDate={moment(startDate)}
        startDateId={`${title}_start_id`}
        endDate={moment(endDate)}
        endDateId={`${title}_end_id`}
        onDatesChange={this.handleDatesChanged}
        focusedInput={focusedInput}
        onFocusChange={fi => this.setState({ focusedInput: fi })}
        hideKeyboardShortcutsPanel
        isOutsideRange={() => false}
        isDayBlocked={() => false}
        disabled={disabled}
        displayFormat="DD.MM.YYYY HH:mm"
        withPortal={usePortal}
        numberOfMonths={useDesktopLayout ? 2 : 1}
        calendarInfoPosition="top"
        renderCalendarInfo={() => (
          <h3 style={styles.infoBox}>{title}</h3>
        )}
        readOnly={!useDesktopLayout}
        minimumNights={0}
      />
    );
  }
}

DateRangePicker.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  disabled: PropTypes.bool,
  useDesktopLayout: PropTypes.bool,
  title: PropTypes.string.isRequired,
  supressPortal: PropTypes.bool,
  onDatesChanged: PropTypes.func.isRequired,
};

DateRangePicker.defaultProps = {
  startDate: null,
  endDate: null,
  disabled: false,
  useDesktopLayout: true,
  supressPortal: false,
};

export default DateRangePicker;
